import { ITEM_SELECTION_ACTION } from "@progress/kendo-react-scheduler/dist/npm/Scheduler";
import queryString from "query-string";
import services from "../../../services";
let data = [];
//var clearGridOnStart = false
const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    console.log(item , "Itemmmmmmm")
    item.ProductID = generateId(data);
    item.inEdit = false;
    // if(item.ProductID > 0 && data.length > 0){
    //     data.length = 0
    // }
    data.unshift(item);
    return data;
};
export const deleteAll = () => {
    data = [];
    return data;
};
export const GetItems = () => {
    return data;
};
export const getItems = async () => {
    var ArrayDetalhesGrid = []
    console.log("teste")
    var queryParams = queryString.parse(window.location.search)
    var  token = queryParams.idPenhora
    var  dataToken = {"idPenhora": token}
    var Detalhes = await services.apiCall.requestApi(
        "/Receita/GetPenhorasGridDetails",
        dataToken,
        "get"
    ); 

    for (let index = 0; index < Detalhes.length ; index++) {
        var idPenhoraTipoOrigemValor = Detalhes[index].idPenhoraTipoOrigemValor;
        var penhoraTipoOrigemValor = Detalhes[index].penhoraTipoOrigemValor;
        var valorPago = Detalhes[index].valorPago;
        var nib = Detalhes[index].nib;
        var dataCriado = Detalhes[index].dataCriado;
        if(dataCriado != null){
            dataCriado = new Date(dataCriado);
            var dia = dataCriado.getDate() < 10 ? "0"+dataCriado.getDate() : dataCriado.getDate();
            var mes = dataCriado.getMonth() + 1 < 10 ? "0"+ (dataCriado.getMonth() +1) : dataCriado.getMonth() +1;
            var ano = dataCriado.getFullYear();
            dataCriado = dia + "/" + mes + "/" + ano;
        }
        
        var criadoPor = Detalhes[index].criadoPor;
        var dataMovimento = Detalhes[index].dataMovimento;

        data.push({ 
            idPenhoraTipoOrigemValor: {text: penhoraTipoOrigemValor , value: idPenhoraTipoOrigemValor},
            ValorPago: valorPago.toFixed(2).replace("." , ","),
            nib: nib,
            DataCriado: dataCriado,
            criadoPor: criadoPor,
            dataMovimento: dataMovimento,
            ProductID: index,
            Discontinued: false,
            Columns: [],
            inEdit: false,
            idPagamento: Detalhes[index].idPenhoraPagamento,
            email : Detalhes[index].email
        })
    }
    return data; 
}

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
